export const closeModal = () => ({
  type: 'CLOSE',
});

export const openModal = () => ({
  type: 'OPEN',
});
